import { jsx as m } from "react/jsx-runtime";
import { textVariants as t } from "./Text.variants.js";
const c = ({
  as: o,
  className: r,
  children: s,
  id: a,
  size: e = t.definition().defaultVariants.size,
  ...i
}) => {
  const { root: n } = t;
  return /* @__PURE__ */ m(o, { className: n({ className: r, size: e }), id: a, ...i, children: s });
};
export {
  c as Text
};
